<template>
  <div>
    <div class="container mb-48">
      <AccountWidget />
      <div class="bg-gray rounded-t-md shadow relative z-50 mt-2 py-1 pb-4 sm:pb-8 md:pb-16 rounded-b-md">
        <div class="text-center relative">
          <button
            class="absolute top-0 left-0 ml-6 mt-1 hover-animate"
            @click="$router.go(-1)"
          >
            <BackIcon />
          </button>
          <h2 class="mt-5 mb-5 text-sm sm:text-2xl font-semibold uppercase text-primary">
            {{ actionTitle }}
          </h2>
        </div>
        <div class="flex flex-wrap items-center">
          <div
            class="border-t border-purple-gray px-4 sm:px-8 lg:px-10 py-8 w-full"
            style="min-height: 300px"
          >
            <ActionProducts :action-products="actionProducts" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ActionProducts from '@/components/Action/ActionProducts';
import AccountWidget from '@/components/AccountWidget';
import BackIcon from '@/assets/icons/back.svg';

export default {
  name: 'Actions',
  components: {
    ActionProducts,
    AccountWidget,
    BackIcon,
  },
  computed: {
    ...mapGetters('action', ['action']),
    actionTitle() {
      const { id } = this.$route.params;

      return this.action(id).name;
    },
    actionProducts() {
      const { id } = this.$route.params;

      return this.action(id).action_products;
    },
  },
};
</script>
